document.addEventListener("DOMContentLoaded", () => {
  const LOADER_KEY = "loader_last_shown";
  const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

  const lastShown = Number(localStorage.getItem(LOADER_KEY));
  if (!isNaN(lastShown) && Date.now() - lastShown < THIRTY_DAYS_MS) {
    // 30日以内に表示されていたらローダーをスキップ
    const loaderEl = document.querySelector(".loader");
    loaderEl?.remove();
    return;
  }

  const SRC_SP = "https://www.takumen.com/st/videos/Takumen_HP_Top_tate_20s_0603.mp4";
  const SRC_PC = "https://www.takumen.com/st/videos/Takumen_HP_Top_20s_0603.mp4";
  const MEDIA_QUERY = "(max-width: 768px)";
  const FADE_MS = 300;

  const loader = document.querySelector(".loader");
  if (!loader) return;

  const video = loader.querySelector("video");
  const source = video?.querySelector("source");
  const btnSkip = loader.querySelector(".btn-skip");

  if (!video || !source) {
    loader.remove();
    return;
  }

  const mq = window.matchMedia(MEDIA_QUERY);
  setVideoSrc(mq.matches);
  mq.addEventListener("change", (e) => setVideoSrc(e.matches));

  function setVideoSrc(isSp) {
    const newSrc = isSp ? SRC_SP : SRC_PC;
    if (source.src.endsWith(newSrc)) return;
    source.src = newSrc;
    video.load();
    video.play().catch(() => {});
  }

  video.addEventListener("loadedmetadata", () => {
    const extra = 100;
    const durMs = Number.isFinite(video.duration)
      ? video.duration * 1000 + extra
      : 8000;
    setTimeout(beginFadeOut, durMs);
  });

  video.addEventListener("ended", beginFadeOut);

  btnSkip?.addEventListener("click", () => {
    beginFadeOut();
  });

  function beginFadeOut() {
    loader.classList.add("is-fading");
    btnSkip?.classList.add("is-hidden");
  }

  loader.addEventListener("transitionend", (e) => {
    if (e.propertyName === "opacity") loader.remove();
  });

  localStorage.setItem(LOADER_KEY, String(Date.now()));
});
